import BaseService from "./baseService";

export default class ImageService extends BaseService {

    getProfileImage(imageId) {
        return this.axiosApiInstance.get(window.API_URL + "/api/image/getProfileImage/" + imageId, { responseType: 'arraybuffer' });
    }

}